module.exports = __webpack_public_path__ + "../resources/graphql/schema.all.min-651cdfe035ea310d985969e06008e718.graphql";